import { create } from 'zustand';

interface BatchSelectionDrawerStore {
  isDrawerOpen: boolean;
  setIsDrawerOpen: (isOpen: boolean) => void;
}

export const useBatchSelectionDrawerStore = create<BatchSelectionDrawerStore>(
  set => ({
    isDrawerOpen: false,
    setIsDrawerOpen: (isOpen: boolean) => set({ isDrawerOpen: isOpen }),
  })
);
